import { render, staticRenderFns } from "./FormChannels.vue?vue&type=template&id=61a7b4fd"
import script from "./FormChannels.vue?vue&type=script&lang=js"
export * from "./FormChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports